import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import {
    checkSupportContainerQueries,
    checkSupportWebp,
    DefaultProject,
    device_id_key,
    getGaSessionId,
    getSessionIdA,
    getStatInterfaceObj,
    maxDurationNumber,
    package_id_key,
    STAT_CONFIG_IS_OPEN_GTM,
    StatGetDeviceId,
    StatGetFromPageId,
    StatGetFromPathname,
    StatGetPackageId,
    StatGetPageId,
    StatGetUserId,
    StatSetFromPageId,
    StatSetFromPathname,
} from './config';
import { getCookie } from './utils/getCookie';
import { getDeviceHeight, getDeviceWidth } from './utils/getDeviceWidth';
import { getPageSource } from './utils/getPageSource';

//主变量集合
const __variablesMapA: any = {
    page_id: '', //页面ID,刷新页面时会更新
    user_id: '', //用户ID
    device_id: '', //设备ID
    package_id: '', //访问ID
};
//临时变量集合
const __variablesMapB: any = {
    __timer_page_leave_a: null, //定时器ID-每20s
    __timer_page_leave_b_1: null, //定时器ID-倒计3s执行
    __timer_page_leave_b_2: null, //定时器ID-倒计6s执行
    __timer_page_leave_b_3: null, //定时器ID-倒计26s执行
    __ga_id_have_send: false, //没有发送GA_ID中
    __scroll_wait_flag: false, //滚动-等待中
    __scroll_wait_time_prev: 0, //滚动-时间戳
    __click_wait_flag: false, //点击-等待中
    __click_wait_time_prev: false, //点击-时间戳
    __timer_over_end: false, //倒计多次结束
};
// 是否已发送模块ID
const __hadSendMapA: any = {};

const BhStat = {
    locale: '',
    appId: 0,
    project: '',
    StatInterface: {} as any,
    systemTimestamp: 0,
    timeDifference: 0, //本地时间-系统时间
    currentIntervalCount: 0, //已经倒计了多少次了;用于记录最多倒计多少就停止页面数据上报
    __href: '',
    getBhTimes: () => {
        return Date.now() - BhStat.timeDifference;
    },
    init: async ({
        locale,
        appId,
        project,
        systemTimestamp,
        textIdA1,
    }: {
        locale: string;
        appId: number;
        project: string;
        systemTimestamp: number;
        textIdA1?: string;
    }) => {
        if (STAT_CONFIG_IS_OPEN_GTM && appId && locale) {
            BhStat.appId = appId || 0;
            BhStat.locale = locale || '';
            BhStat.__href = location.href || ''; //页面离开时好像拿不到location.href这个值
            // project start
            const projectB2 = project || 'ecoflow';
            BhStat.project = projectB2;
            BhStat.StatInterface = getStatInterfaceObj(locale, project);
            // project end
            BhStat.systemTimestamp = systemTimestamp || Date.now();
            const localTimestamp = Date.now(); //本地时间戳
            BhStat.timeDifference = localTimestamp - BhStat.systemTimestamp || 0;
            __variablesMapA.device_id = await StatGetDeviceId({
                textIdA1,
            });
            __variablesMapA.package_id = StatGetPackageId();
            __variablesMapA.page_id = StatGetPageId(__variablesMapA.package_id);
            __variablesMapA.user_id = StatGetUserId();

            BhStat.createVisitor(); // 创建用户-1
            BhStat.createPackage(); //创建用户-2
            BhStat.enterPage(); // 创建页面
            EcoDesignEventsBus.emit('GtmModuleData-send', true); //创建楼层埋点
            BhStat.leaveSetInterval(); // 创建定时器
        }
    },
    // 进入页面
    enterPage: async () => {
        if (!BhStat.appId) {
            return;
        }
        const from_source = getPageSource() || DefaultProject;
        const from_page_id = StatGetFromPageId();
        const from_pathname = StatGetFromPathname();
        const the_pathname = location.pathname; //本页面路径
        const ga_id = getCookie('_ga');
        const ga_session_id = getGaSessionId();
        const sendData: any = {
            page_id: __variablesMapA.page_id,
            device_id: __variablesMapA.device_id,
            package_id: __variablesMapA.package_id,
            page_href: location.href,
            from_source: from_source,
            ga_id: ga_id,
            ga_session_id: ga_session_id,
            time_enter: BhStat.getBhTimes(),
        };
        // 存在上一个页面ID
        if (from_page_id && from_page_id !== __variablesMapA.page_id) {
            sendData.from_page_id = from_page_id;
        }
        if (from_pathname && from_pathname !== the_pathname) {
            sendData.from_pathname = from_pathname;
        }

        BhStat.send(sendData, BhStat.StatInterface.createVisitTimeUrl);
        StatSetFromPageId(__variablesMapA.page_id); //将本页面的进入事件发送后,设置进入的页面ID
        StatSetFromPathname(the_pathname);
    },
    // 离开页面|更新离开时间
    leavePage: async () => {
        if (!BhStat.appId) {
            return;
        }
        const ga_id = getCookie('_ga');
        const ga_session_id = getGaSessionId();
        BhStat.send(
            {
                page_id: __variablesMapA.page_id,
                package_id: __variablesMapA.package_id,
                ga_id: ga_id,
                ga_session_id: ga_session_id,
                time_leave: BhStat.getBhTimes(),
            },
            BhStat.StatInterface.updateVisitTimeUrl,
        );
    },
    // 离开页面|更新离开时间
    leavePageFromPathname: async (href?: string) => {
        if (!href) {
            return;
        }
        try {
            const urlA = new URL(href);
            const pathnameA = `${urlA.origin}${urlA.pathname}`;
            const pathnameB = `${location.origin}${location.pathname}`;
            // 本页面和下1个页面链接一样
            if (pathnameA !== pathnameB) {
                BhStat.send(
                    {
                        page_id: __variablesMapA.page_id,
                        package_id: __variablesMapA.package_id,
                        to_pathname: pathnameA,
                        time_leave: BhStat.getBhTimes(),
                    },
                    BhStat.StatInterface.updateVisitTimeUrl,
                );
            }
        } catch (error) {}
    },
    // 设置定时器,每20秒发送一次
    leaveSetInterval: async () => {
        BhStat.leaveSetIntervalA();
        clearTimeout(__variablesMapB.__timer_page_leave_b_1);
        __variablesMapB.__timer_page_leave_b_1 = setTimeout(() => {
            BhStat.leavePage();
            EcoDesignEventsBus.emit('GtmModuleData-send');
        }, 4 * 1000);

        clearTimeout(__variablesMapB.__timer_page_leave_b_3);
        __variablesMapB.__timer_page_leave_b_3 = setTimeout(() => {
            BhStat.leavePage();
            EcoDesignEventsBus.emit('GtmModuleData-send');
            __variablesMapB.__timer_over_end = true;
        }, 9 * 1000);
    },
    leaveSetIntervalA: async () => {
        window.addEventListener('scroll', () => {
            if (!__variablesMapB.__timer_over_end) {
                // 还在倒计时中
                return;
            }
            if (__variablesMapB.__scroll_wait_flag) {
                return;
            }
            // 用于减少触发次数-start
            __variablesMapB.__scroll_wait_flag = true;
            setTimeout(() => {
                __variablesMapB.__scroll_wait_flag = false;
            }, 300);
            // 用于减少触发次数-end

            // 校验多少s内触发1次-start
            const nowTimerA = Date.now();
            const prevTimer = __variablesMapB.__scroll_wait_time_prev;
            const onceTimeA = 5 * 1000; //最多5s触发一次
            if (nowTimerA < onceTimeA + prevTimer) {
                return;
            }
            __variablesMapB.__scroll_wait_time_prev = Date.now();
            __variablesMapB.__click_wait_time_prev = Date.now();
            // 校验多少s内触发1次-end
            // 执行页面更新
            BhStat.leavePage();
            BhStat.updateVisitor();
            // 执行模块更新
            EcoDesignEventsBus.emit('GtmModuleData-send');
        });
        window.addEventListener('click', () => {
            if (!__variablesMapB.__timer_over_end) {
                // 还在倒计时中
                return;
            }
            // 校验多少s内触发1次-start
            const nowTimerA = Date.now();
            const prevTimer = __variablesMapB.__click_wait_time_prev;
            const onceTimeA = 5 * 1000; //最多5s触发一次
            if (nowTimerA < onceTimeA + prevTimer) {
                return;
            }
            __variablesMapB.__scroll_wait_time_prev = Date.now();
            __variablesMapB.__click_wait_time_prev = Date.now();
            // 校验多少s内触发1次-end
            // 执行页面更新
            BhStat.leavePage();
            BhStat.updateVisitor();
            // 执行模块更新
            EcoDesignEventsBus.emit('GtmModuleData-send');
        });
    },
    push: async (params: any) => {
        const from_source = getPageSource() || DefaultProject;

        const data = {
            event: 'uaEvent',
            ...params,
            device_id: __variablesMapA.device_id,
            package_id: __variablesMapA.package_id,
            page_id: __variablesMapA.page_id,
            ga_id: getCookie('_ga'),
            ga_session_id: getGaSessionId(),
            page_href: BhStat.__href || location.href,
            from_source: from_source,
        };
        // 去掉官网没有 event_name 的埋点
        const isNoAllowA1 = location.origin === 'https://www.ecoflow.com';
        const isNoAllowA2 = !data.event_name && !data.__btn_id1;
        const isNoAllowB = isNoAllowA1 && isNoAllowA2;
        if (isNoAllowB) {
            return '';
        }

        if (data.page_href) {
            BhStat.send(data, BhStat.StatInterface.baseUrlGa4);
        }

        //navigator.sendBeacon(BhStat.baseUrlGa4, JSON.stringify(data));
    },
    // 创建访问者-1
    createVisitor: async () => {
        if (!BhStat.appId) {
            return;
        }
        // 是否已发送过
        const has_send_key_visitor = `${device_id_key}_visitor_has_send`;
        const device_id_key_has_send = localStorage.getItem(has_send_key_visitor);
        if (device_id_key_has_send) {
            return;
        }
        const device_w = getDeviceWidth();
        const device_h = getDeviceHeight();
        const from_source = getPageSource() || DefaultProject;
        const ga_id = getCookie('_ga');

        const data: any = {
            device_id: __variablesMapA.device_id,
            package_id: __variablesMapA.package_id,

            device_w,
            device_h,

            page_href: location.href,
            from_source: from_source,
            timestamp: BhStat.getBhTimes(),
            ga_id: ga_id,
        };
        // ga_id 已发送
        if (ga_id) {
            __variablesMapB.__ga_id_have_send = true;
        }

        BhStat.send(data, BhStat.StatInterface.createVisitorUrl);
        localStorage.setItem(has_send_key_visitor, '1'); //标记成已发送
        //navigator.sendBeacon(BhStat.baseUrlGa4, JSON.stringify(data));
    },
    // 更新访问者
    updateVisitor: async () => {
        // 已发送 ga_id
        if (__variablesMapB.__ga_id_have_send) {
            return;
        }
        const ga_id = getCookie('_ga');
        const data: any = {
            device_id: __variablesMapA.device_id,
            package_id: __variablesMapA.package_id,

            ga_id,
        };
        if (ga_id) {
            data.ga_id = ga_id;
        }
        // 没有 ga_id 不执行
        if (!ga_id) {
            return;
        }

        __variablesMapB.__ga_id_have_send = true;
        //BhStat.send(data, BhStat.StatInterface.updateVisitorUrl);//好像已失效
        //navigator.sendBeacon(BhStat.baseUrlGa4, JSON.stringify(data));
    },
    // 创建访问者-2
    createPackage: async () => {
        if (!BhStat.appId) {
            return;
        }
        // 是否已发送过
        const has_send_key_package = `${package_id_key}_visitor_has_send`;
        const package_id_key_has_send = localStorage.getItem(has_send_key_package);
        if (package_id_key_has_send) {
            return;
        }

        const from_source = getPageSource() || DefaultProject;
        const ga_id = getCookie('_ga');
        const browser_is_webp = await checkSupportWebp();
        const data: any = {
            device_id: __variablesMapA.device_id,
            package_id: __variablesMapA.package_id,

            page_href: location.href,
            from_source: from_source,
            timestamp: BhStat.getBhTimes(),
            ga_id: ga_id,

            browser_is_css_container_query: checkSupportContainerQueries(),
            browser_is_webp: browser_is_webp,
        };
        // ga_id 已发送
        if (ga_id) {
            __variablesMapB.__ga_id_have_send = true;
        }

        BhStat.send(data, BhStat.StatInterface.createPackageUrl);
        localStorage.setItem(has_send_key_package, '1'); //标记成已发送
        //navigator.sendBeacon(BhStat.baseUrlGa4, JSON.stringify(data));
    },
    // 页面模块--进入
    pageModuleCreate: async (params: any, options?: any) => {
        if (!BhStat.appId) {
            return;
        }
        const { moduleId, moduleId1, moduleId2, title, enterCount, enterTime, leaveTime, duration } = params;
        const page_id = __variablesMapA.page_id;
        const page_module_id = `${page_id}_${params.moduleId}_${params.enterCount}`; //记录的主键(页面ID,模块ID,当前模块进入次数)
        if (!enterTime || !leaveTime || !duration) {
            return;
        }
        const ga_id = getCookie('_ga');
        const ga_session_id = getGaSessionId();
        const dataA: any = {
            device_id: __variablesMapA.device_id,
            package_id: __variablesMapA.package_id,
            ga_id: ga_id || '',
            ga_session_id: ga_session_id || '',

            page_href: location.href,
            page_id,
            page_module_id,
            module_id: moduleId,
            module_id_1: moduleId1 || '',
            module_id_2: moduleId2 || '',

            module_title: title,
            enter_count: enterCount,
            time_enter: enterTime,
            time_leave: leaveTime,
            time_duration: duration, //停留时间
        };

        // 最多停留30分钟
        if (dataA.time_duration > maxDurationNumber) {
            return;
        }

        // 该主键已发送过数据;更新时间
        if (__hadSendMapA[page_module_id]) {
            BhStat.send(
                {
                    device_id: dataA.device_id,
                    page_module_id,
                    time_leave: dataA.time_leave,
                    time_duration: dataA.time_duration,
                },
                BhStat.StatInterface.baseUrlPageModuleUpdate,
            );
            return;
        }
        __hadSendMapA[page_module_id] = true;
        BhStat.send(dataA, BhStat.StatInterface.baseUrlPageModuleCreate);
    },
    // 页面模块-离开
    pageModuleUpdate: async (params: any, options?: any) => {
        if (!BhStat.appId) {
            return;
        }
        const { moduleId, duration, enterCount } = params;
        const page_id = __variablesMapA.page_id;
        const page_module_id = `${page_id}_${moduleId}_${enterCount}`; //记录的主键(页面ID,模块ID,当前模块进入次数)
        const ga_id = getCookie('_ga');
        const ga_session_id = getGaSessionId();
        const data = {
            device_id: __variablesMapA.device_id,
            page_id,
            page_module_id,
            module_id: moduleId,
            time_duration: duration,
            ga_id: ga_id || '',
            ga_session_id: ga_session_id || '',
        };
        BhStat.send(data, BhStat.StatInterface.baseUrlPageModuleUpdate);
    },
    send: async (data: any, sendUrl?: any) => {
        if (!BhStat.appId) {
            return;
        }
        const app_id = BhStat.appId;
        try {
            const formData = new URLSearchParams();
            const user_id = __variablesMapA.user_id || StatGetUserId();
            for (const key in data) {
                if (key === 'event_parameters') {
                    continue;
                }
                formData.append(key, data[key]);
            }
            const event_parameters = data?.event_parameters; //很多GA的数据存放在统一的参数格式中
            if (event_parameters && typeof event_parameters === 'object') {
                for (const key in event_parameters) {
                    formData.append(key, event_parameters[key]);
                }
            }
            const session_id = getSessionIdA();
            formData.append('session_id', session_id);
            formData.append('app_id', `${app_id}`);
            formData.append('project', BhStat.project || DefaultProject);
            if (user_id) {
                formData.append('user_id', user_id);
            }
            navigator.sendBeacon(sendUrl || BhStat.StatInterface.baseUrlGa4, formData); //formData);
        } catch (e) {}
    },
};

export default BhStat;
